$(document).ready(function() {
  $("#project_owner_identity_proofs_file_front").on("change", function() {
    if ($(this).val() !== "") {
      $("#file_front_presence").val("true");
    } else {
      $("#file_front_presence").val(null);
    };
  });
  $("#project_owner_identity_proofs_file_back").on("change", function() {
    if ($(this).val() !== "") {
      $("#file_back_presence").val("true");
    } else {
      $("#file_back_presence").val(null);
    };
  });
  $("#project_owner_identity_proofs_file").on("change", function() {
    if ($(this).val() !== "") {
      $("#file_presence").val("true");
    } else {
      $("#file_presence").val(null);
    };
  });

  $("input[id^='project_owner_'][id$='_file_front']").on("change", function() {
    var index = $(this).attr('id').match(/\d+/)[0];
    if ($(this).val() !== "") {
      $("#file_front_presence_" + index).val("true");
    } else {
      $("#file_front_presence_" + index).val(null);
    };
  });
  $("input[id^='project_owner_'][id$='_file_back']").on("change", function() {
    var index = $(this).attr('id').match(/\d+/)[0];
    if ($(this).val() !== "") {
      $("#file_back_presence_" + index).val("true");
    } else {
      $("#file_back_presence_" + index).val(null);
    };
  });
});

function selectDocument(event) {
  rectoVerso(event);
  resetFileInput();
}

function rectoVerso(event) {
  const mainContainer = $("#recto_and_verso_container");
  const statusContainer = $("#recto_and_verso_container_status");
  mainContainer.removeClass("d-none");
  statusContainer.removeClass("d-none");

  const rectoVersoContainer = $("#recto_or_verso_container");
  const singleDocumentHint = $("#single_document_hint");
  documentsArray = ["0", "5", "11"]

  if (documentsArray.includes(event.value)) {
    rectoVersoContainer.removeClass("d-none");
    singleDocumentHint.removeClass("d-none")
  } else {
    rectoVersoContainer.addClass("d-none");
    singleDocumentHint.addClass("d-none")
  }
}

function resetFileInput() {
  // Delete file from input and its presence
  const fileInput = document.getElementById("project_owner_identity_proofs_file");
  const fileFrontInput = document.getElementById("project_owner_identity_proofs_file_front");
  const fileBackInput = document.getElementById("project_owner_identity_proofs_file_back");

  fileInput.value = "";
  fileFrontInput.value = "";
  fileBackInput.value = "";

  $("#file_presence").val(null);
  $("#file_front_presence").val(null);
  $("#file_back_presence").val(null);

  // Label styling to act new
  const uploadedButton = document.querySelectorAll(".custom-file-input");
  const reUploadIcon = document.querySelectorAll(".re-upload-icon");
  const uploadIcon = document.querySelectorAll(".upload-icon");

  for (i = 0; i < uploadedButton.length; i++) {
    var uploadLabel = uploadedButton[i].parentNode.querySelector("label");
    if (uploadLabel.classList.contains("btn-primary")) {
      uploadLabel.classList.remove("btn-primary");
      uploadLabel.classList.add("btn-file");

      reUploadIcon[i].classList.add("d-none");
      uploadIcon[i].classList.remove("d-none");

      var spanLabel = uploadLabel.querySelector("span");
      spanLabel.innerHTML = "Choisir un document"
    }
  }
}

$(document).ready(function() {
  $("#identity_proof_selector").on("change", function() {
    let selected_option = $("#identity_proof_selector").find(":selected");
    if (selected_option.index() == 5) {
      $(".driving-license-label").removeClass("d-none");
    } else {
      $(".driving-license-label").addClass("d-none");
    }
  })
})
